import "../pages.scss"
import { TemporadasState } from '../../context/temporadas/TemporadasState';
import Datatable from "./temporadasTable/Datatable"

const TemporadasPage = () => {
  return (
    <>
      <TemporadasState>
        <Datatable />
      </TemporadasState>
    </>
  )
}

export default TemporadasPage